import ajax from '@/plugin/ajax'
import utils from '@/common/utils'
import qs from 'qs'

export const modifyPwdByPhone = function (pwd) {
    return new Promise((resolve, reject) => {
        ajax.post('/lg/secure/user/password', {
            password: utils.md5(pwd)
        }).then(res => {
            if (res.status === 200) {
                resolve(res.data)
            } else {
                reject(res.status)
            }
        })
    })
}

export const modifyPwdByOldPwd = function (oldPwd, newPwd) {
    return new Promise((resolve, reject) => {
        ajax.post('/lg/user/password', {
            old_password: utils.md5(oldPwd),
            new_password: utils.md5(newPwd)
        }).then(res => {
            if (res.status === 200) {
                resolve(res.data)
            } else {
                reject(res.status)
            }
        })
    })
}

export const getAgencyStatus = function (mails) {
    let ids = (mails.map(m => m.id)).join(',')
    return new Promise((resolve, reject) => {
        ajax.get('/vipapi/pop_end/status', {
            params: {
                id: ids,
                t: +new Date()
            }
        }).then(res => {
            res.forEach(data => {
                mails.forEach(mail => {
                    if (data.id == mail.id) {
                        data.email = mail.popuserid
                    }
                })
            })
            resolve(res)
        })
    })
}

export const getSecureCode = function (category, type, mobile) {
    return new Promise((resolve, reject) => {
        ajax.get(`/lg/secure/mobile/${category}`, {
            params: {
                way: type || 0,
                mobile: mobile
            }
        }).then(res => {
            if (res.status === 200) {
                resolve(res.data)
            } else {
                reject(res.status)
            }
        })
    })
}

export const setProtocol = function (pop3, imap, captcha) {
    let smtp = pop3 || imap
    return new Promise((resolve, reject) => {
        ajax.post('/vipapi/protocol', {
            pop3,
            smtp,
            imap,
            captcha
        }).then(res => {
            resolve(res)
        })
    })
}
export const setProtocolVerify = function (pop3, imap) {
    let smtp = pop3 || imap
    return new Promise((resolve, reject) => {
        ajax.post('/vipapi/protocol/verifyAndModify', {
            pop3,
            smtp,
            imap
        }).then(res => {
            resolve(res)
        })
    })
}

export const getProtocol = function () {
    return new Promise((resolve, reject) => {
        ajax.get('/vipapi/protocol').then(res => {
            if (res.status === 200) {
                resolve(res.data)
            } else {
                reject(res.status)
            }
        })
    })
}

export const setBaseConfig = function (data) {
    return new Promise((resolve, reject) => {
        ajax.post('/vipapi/baseSet', utils.mailParam(data), {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(res => {
            if (res.status === 200) {
                resolve(res.data)
            } else {
                reject(res.status)
            }
        })
    })
}

export const addAgency = function (data) {
    return new Promise((resolve, reject) => {
        ajax.put('/vipapi/pop', qs.stringify(data), {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(res => {
            if (res.status === 200) {
                resolve(res.data)
            } else {
                reject(res.status)
            }
        })
    })
}

export const deleteAgency = function (currentAddr, popAddr) {
    return new Promise((resolve, reject) => {
        ajax.delete('/vipapi/pop', {
            params: {
                userid: currentAddr,
                popuserid: popAddr
            }
        }).then(res => {
            if (res.status === 200) {
                resolve(res.data)
            } else {
                reject(res.status)
            }
        })
    })
}

export const updateAgency = function (data) {
    return new Promise((resolve, reject) => {
        ajax.post('/vipapi/pop/update', qs.stringify(data), {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(res => {
            if (res.status === 200) {
                resolve(res.data)
            } else {
                reject(res.status)
            }
        })
    })
}

export const getPopInfo = function (currentAddr, popAddr) {
    return new Promise((resolve, reject) => {
        ajax.get('/vipapi/pop', {
            params: {
                userid: currentAddr,
                popuserid: popAddr
            }
        }).then(res => {
            if (res.status === 200) {
                resolve(res.data)
            } else {
                reject(res.status)
            }
        })
    })
}

export const getAgencyList = function () {
    return new Promise((resolve, reject) => {
        ajax.get('/vipapi/folders').then(res => {
            if (res.status === 200) {
                let folders = res.data.folders,
                    multiMails = folders.filter(folder => folder.type === 'multiMails')
                resolve(multiMails)
            } else {
                reject(res.status)
            }
        })
    })
}

export const setSenderDisplayName = function (displayName, replyAddr) {
    return new Promise((resolve, reject) => {
        ajax.post('/vipapi/senderSet', utils.mailParam({
            displayName: displayName,
            replyAddr: replyAddr
        }), {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(res => {
            if (res.status === 200) {
                resolve(res.data)
            } else {
                reject(res.status)
            }
        })
    })
}

export const getSenderDisplayName = function () {
    return new Promise((resolve, reject) => {
        ajax.get('/vipapi/senderSet').then(res => {
            if (res.status === 200) {
                resolve(res.data)
            } else {
                reject(res.status)
            }
        })
    })
}

export const veritySecureCode = function (category, code) {
    return new Promise((resolve, reject) => {
        ajax.post(`/lg/secure/mobile/${category || 0}`, {
            smcode: code
        }).then(res => {
            if (res.status === 200) {
                resolve(res.data)
            } else {
                reject(res.status)
            }
        })
    })
}

export const setAvatar = function (data) {
    return new Promise((resolve, reject) => {
        ajax.post('/vipapi/avatar/set', data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(res => {
            if (res.status === 200) {
                resolve(res)
            } else {
                reject(res.status)
            }
        })
    })
}

export const getSkinList = function () {
    return new Promise((resolve, reject) => {
        ajax.get('/vipapi/skin').then(res => {
            if (res.status === 200) {
                resolve(res.data)
            } else {
                reject(res.status)
            }
        })
    })
}

export const setSkin = function (id) {
    return new Promise((resolve, reject) => {
        ajax.post('/vipapi/skin', {
            skinId: id
        }).then(res => {
            if (res.status === 200) {
                resolve()
            } else {
                reject(res.status)
            }
        })
    })
}

export const getCurrentSkin = function() {
    return new Promise((resolve, reject) => {
        ajax.get('/vipapi/skin/user').then(res => {
            if(res.status === 200) {
                resolve(res.data)
            } else {
                reject(res.status)
            }
        })
    })
}

export const setAutoReply = function (data) {
    return ajax({
        method: 'POST',
        url: '/vipapi/autoReply',
        data: utils.mailParam(data),
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}
export const getAutoReply = function () {
    return ajax({
        method: 'get',
        url: '/vipapi/autoReply'
    })
}

export const getSign = function () {
    return ajax({
        method: 'get',
        url: '/vipapi/getSign/v2'
    })
}
export const postSign = function (data) {
    return ajax({
        method: 'POST',
        url: '/vipapi/postSign/v2',
        data: utils.mailParam(data),
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}
export const deleteSign = function (id) {
    return ajax({
        method: 'POST',
        url: '/vipapi/deleteSign/v2',
        data: utils.mailParam({
            signatureId: id
        }),
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}
export const getAutoForward = function () {
    return ajax({
        method: 'get',
        url: '/vipapi/autoForward'
    })
}
export const setAutoForward = function (data) {
    return ajax({
        method: 'post',
        url: '/vipapi/autoForward',
        data: data
    })
}
export const getSecurity = function (t) {
    return ajax({
        method: 'post',
        url: '/vipapi/phone/msg/security',
        data: utils.mailParam({
            method: t
        }),
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}
export const forwardVerify = function (id) {
    return ajax({
        method: 'post',
        url: '/vipapi/forwardVerify',
        data: utils.mailParam({
            forwardId: id
        }),
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}

export const getFilterlist = function () {
    return ajax({
        method: 'get',
        url: '/vipapi/filter/v2/list'
    })
}
export const getFilterByid = function (ruleId) {
    return ajax({
        method: 'get',
        url: `/vipapi/filter/v2/${ruleId}`
    })
}
export const setFilter = function (data) {
    return ajax({
        method: 'POST',
        url: `/vipapi/filter/v2`,
        data: data
    })
}
export const modifyFilter = function (data) {
    return ajax({
        method: 'POST',
        url: `/vipapi/filter/v2/${data.id}`,
        data: data
    })
}

export const delFilter = function (ruleId) {
    return ajax({
        method: 'DELETE',
        url: `/vipapi/filter/v2/${ruleId}`
    })
}
export const sortFilter = function (ruleIdA, ruleIdB) {
    return ajax({
        method: 'POST',
        url: `/vipapi/filter/v2/sort`,
        data: utils.mailParam({
            ruleIdA: ruleIdA,
            ruleIdB: ruleIdB
        }),
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}
export const switchFilter = function (ruleId, state) {
    return ajax({
        method: 'POST',
        url: `/vipapi/filter/v2/switch/${ruleId}`,
        data: utils.mailParam({
            ruleId: ruleId,
            state: state
        }),
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}



// WEBPACK FOOTER //
// ./src/service/settingService.js